module.exports = {
	extends: [
		'/',
		'base',
		'trees',
		'tree'
	],

	config: {
		treeConfig: {
			plugins: [
				'types',
				'search'
			],
			core: {
				data: undefined
			}
		}
	}
};
